/**
 * DemoBadge — small "Demo Environment" pill shown when the logged-in user
 * is part of the public demo tenant.
 *
 * Hidden for all real customers. No layout impact. Responsive:
 *   • Desktop: shown in the location-switcher bar, right of the location chip.
 *   • Mobile : shown in the mobile header next to the brand mark.
 */
import React from 'react';
import { Eye } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { isDemoUser } from '../lib/demo';

export default function DemoBadge({ compact = false }) {
  const { user } = useAuth();
  if (!isDemoUser(user)) return null;

  if (compact) {
    return (
      <span
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide bg-amber-100 text-amber-800 border border-amber-200"
        data-testid="demo-badge-compact"
        title="You're viewing the SparkleClean demo — all writes are disabled"
      >
        <Eye size={10} className="shrink-0" />
        Demo
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wide bg-amber-100 text-amber-800 border border-amber-200 shrink-0"
      data-testid="demo-badge"
      title="You're viewing the SparkleClean demo — all writes are disabled"
    >
      <Eye size={12} className="shrink-0" />
      Demo Environment
    </span>
  );
}
